export class AudioContextFactory {
  private static audioContext: AudioContext | undefined

  static getAudioContext(): AudioContext {
    // AudioContext instance has to be created after first user interaction,
    // otherwise its state will be suspended.
    // This code assumes that the first AudioContext usage is made after some user action.
    // Providing access to user devices is also considered as user interaction
    // event if it's done automatically based on user selection from previous visits.
    return this.audioContext || (this.audioContext = this.createAudioContext())
  }

  private static createAudioContext(): AudioContext {
    const Constructor = this.getAudioContextConstructor()
    const audioContext = new Constructor()

    // Sample rate must be between 11025 and 48000 inclusive
    // https://github.com/etercast/mp3/blob/master/src/mp3.c#L52
    if (audioContext.sampleRate < 11025 || audioContext.sampleRate > 48000) {
      audioContext.close()

      return new Constructor({
        sampleRate: audioContext.sampleRate > 48000 ? 48000 : 44100,
      })
    }

    return audioContext
  }

  private static getAudioContextConstructor(): { new (options?: AudioContextOptions): AudioContext } {
    // @ts-ignore
    return window.AudioContext || window.webkitAudioContext
  }
}
